import {
  CompassCardComponent,
  CompassCardComponentProps,
} from 'react-scale/corp/views/DataCompassV2/types';
import { Column } from '@scale/compass-shared/types';
import useGroupByCard from './useGroupByCard';
import { useEffect } from 'react';
import { Flex, Text, Select, Box } from '@scale/scaleui-radix';
import { useCompassCard } from '@scale/compass-ui/store';

const GroupByCardComponent: CompassCardComponent = ({ index }: CompassCardComponentProps) => {
  const {
    updateCardCanSubmit,
    columnToGroup,
    columnToGroupBy,
    setColumnToGroup,
    setColumnToGroupBy,
  } = useGroupByCard(index);
  const { retrievedOutput } = useCompassCard(index - 1);
  const columns = retrievedOutput?.response?.schema ?? [];

  useEffect(() => {
    const canSubmit = !!columnToGroup && !!columnToGroupBy;
    updateCardCanSubmit(canSubmit);
  }, [columnToGroup, columnToGroupBy]);

  return (
    <Flex gap="4" direction="row" align="center">
      <Text>Group</Text>
      <Box maxWidth="300px">
        <Select.Root
          value={columnToGroup?.id}
          onValueChange={(value: string | null) => setColumnToGroup(value ?? '')}
        >
          <Select.Trigger id="group-select" placeholder="Select a column to group..." />
          <Select.Content>
            {columns.map((column: Column) => (
              <Select.Item key={column.id ?? '-'} value={column.header ?? '-'}>
                {column.header ?? '-'}
              </Select.Item>
            ))}
          </Select.Content>
        </Select.Root>
      </Box>
      <Text>by</Text>
      <Box maxWidth="300px">
        <Select.Root
          value={columnToGroupBy?.id}
          onValueChange={(value: string | null) => setColumnToGroupBy(value ?? '')}
        >
          <Select.Trigger id="group-by-select" placeholder="Select column to group by" />
          <Select.Content>
            {columns.map((column: Column) => (
              <Select.Item key={column.id ?? '-'} value={column.header ?? '-'}>
                {column.header ?? '-'}
              </Select.Item>
            ))}
          </Select.Content>
        </Select.Root>
      </Box>
    </Flex>
  );
};

export default GroupByCardComponent;
